import styled from "styled-components";

export const Container = styled.section`
  .cards {
    width: 100%;
    margin: 90px 0%;
    margin-left: 10px;
    margin-bottom: 0px;
    position: relative;
    display: flex;
    justify-content: space-around;
    z-index: 100;
  }
  .images {
    width: 98.7vw;
    margin-top: -20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 0px;
    z-index: -1;
  }

  .mobile {
    display: none;
  }

  #editor-feature {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0;
    height: 420px;

    img {
      height: 100%;
    }
  }

  #editor-feature-studio-shot {
    width: 60%;
    object-fit: cover;
    object-position: 50% 50%;
  }

  #editor-feature-screen-shot {
    width: 55%;
    object-fit: cover;
    object-position: 0% 0%;
  }

  .editor-feature-cta {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    background: ${(props) => props.theme.background1};
    max-width: 600px;
    width: 50%;
    height: 134px;
    padding: 20px;
    gap: 12px;
    border-radius: 8px;

    .editor-feature-regions {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 60%;

      .region {
        height: 30px;
        border-radius: 8px;
      }

      .region-1 {
        display: flex;
        background-color: #a06cb2;
        width: 100%;
        justify-content: center;
        align-items: center;
        font-family: "AvenirLTPro-Heavy";
        font-size: 16px;
        color: #d8d8d8;
        line-height: 20px;
      }

      .region-2 {
        background-color: #b2926c;
        width: 60%;
        align-self: flex-end;
        margin-right: 20px;
      }

      .region-3 {
        background-color: #6c80b2;
        width: 70%;
        align-self: flex-end;
        margin-right: 40px;
      }
    }

    .editor-feature-text {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 8px;

      .editor-feature-header {
        font-family: "AvenirLTPro-Heavy";
        font-size: 17px;
        color: #d8d8d8;
        text-align: center;
      }

      .editor-feature-body {
        font-family: "AvenirLTPro-Light";
        font-size: 15px;
        font-style: italic;
        color: #979797;
        text-align: center;
      }

      .editor-feature-funnel {
        display: flex;
        justify-content: center;
      }

      .btn-editor-demo {
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        background-color: #5d95aa;
        border-radius: 44px;
        font-family: AvenirLTPro-Heavy;
        font-size: 16px;
        cursor: pointer;
        outline: none;
        padding: 6px 20px;
        border: none;
        font-size: 15px;
        line-height: 15px;
      }
    }
  }

  #editor-feature-floater {
    position: absolute;
    top: 77px;
    left: 36%;
  }

  @media (max-width: 1090px) {
    .editor-feature-cta {
      left: 0 !important;
      right: 0 !important;
      margin: auto;
    }

    .editor-feature-regions {
      display: none !important;
    }
  }

  @media (max-width: 1000px) {
    .cards {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 32px;
    }

    .studio-img-mobile {
      margin-top: 24px;
    }

    .mobile {
      display: block;
    }

    .desktop {
      display: none;
    }
  }
`;

export const Card = styled.div`
  background-color: ${(props) => props.theme.backgroundDark};
  box-shadow: ${(props) => props.theme.cardShadow};
  border-radius: 12px;
  padding: 12px;
  max-width: 328px;
  display: flex;
  align-items: center;
  margin-right: 30px;

  p {
    text-align: center;
    font-size: ${(props) => props.theme.p2m.fs};
    font-family: ${(props) => props.theme.p2b.ff};
    color: ${(props) => props.theme.white};
    line-height: 30px;
    padding: 0px 24px;
    width: 100%;

    .pink {
      color: #e1b0e4;
    }

    .purple {
      color: #9cabe9;
    }

    .blue {
      color: ${(props) => props.theme.highlight};
    }
  }

  @media (max-width: 1000px) {
    max-width: 90vw;
    width: 86vw;
    margin-bottom: 18px;

    .card p {
      text-align: center;
    }
  }
`;
